const headRows = {
  file: 'Arquivo',
  modifiedAt: 'Modificado em',
  size: 'Tamanho',
  download: 'Download',
  description: 'Descrição'
};

export default headRows;
